import { TAG_RIM, convexHull, diskAabb } from '../tagLayout';
import { NODE_CORE_RADIUS } from './vectors';

export function hugLiveNodes(bunch, meshByTaskId) {
  const key = bunch.userData.clusterKey;
  if (!key || !meshByTaskId) return;
  const pts = [];
  meshByTaskId.forEach((mesh) => {
    const ud = mesh.userData;
    if (ud?.nodeMeta?.clusterKey !== key) return;
    if (!mesh.visible || ud.exiting || (ud.visT ?? 1) < 0.05) return;
    const worldR = NODE_CORE_RADIUS * (ud.layoutScale > 0 ? ud.layoutScale : Math.max(mesh.scale.x, ud.nodeMeta?.size ?? 1));
    pts.push({ x: mesh.position.x, y: mesh.position.y, r: worldR });
  });
  if (!pts.length) return;
  const box = diskAabb(pts);
  const pad = 0.22;
  let maxR = NODE_CORE_RADIUS;
  pts.forEach((p) => { maxR = Math.max(maxR, p.r); });
  bunch.userData.contentOffX = box.cx - bunch.position.x;
  bunch.userData.contentOffY = box.cy - bunch.position.y;
  bunch.userData.contentW = Math.max(box.hw + pad, 0.35);
  bunch.userData.contentH = Math.max(box.hh + pad, 0.35);
  bunch.userData.titleHullR = maxR;
  bunch.userData.titleHull = convexHull(pts).map((p) => ({
    x: p.x - bunch.position.x,
    y: p.y - bunch.position.y,
  }));
}

export function contentEllipse(bunch) {
  return {
    ox: bunch.userData.contentOffX ?? 0,
    oy: bunch.userData.contentOffY ?? 0,
    hw: bunch.userData.contentW ?? Math.max(0.5, (bunch.userData.halfW || 2) * 0.3),
    hh: bunch.userData.contentH ?? Math.max(0.5, (bunch.userData.halfH || 2) * 0.3),
  };
}

export function titleEllipse(bunch) {
  const c = contentEllipse(bunch);
  return { ox: c.ox, oy: c.oy, hw: c.hw + TAG_RIM, hh: c.hh + TAG_RIM };
}

export function rimAt(bunch, angle, rimK = 1, inward = 1) {
  const c = contentEllipse(bunch);
  const hw = (c.hw + TAG_RIM * rimK) * inward;
  const hh = (c.hh + TAG_RIM * rimK) * inward;
  return {
    x: c.ox + Math.cos(angle) * hw,
    y: c.oy + Math.sin(angle) * hh,
    z: bunch.userData.tagZ ?? 0.45,
  };
}

export function applyTagLocal(bunch, tag, local) {
  const c = contentEllipse(bunch);
  tag.position.set(local.x, local.y, local.z);
  bunch.userData.tagLocalX = local.x;
  bunch.userData.tagLocalY = local.y;
  bunch.userData.tagAngle = Math.atan2(local.y - c.oy, local.x - c.ox);
  const ell = titleEllipse(bunch);
  bunch.userData.tagInward = Math.min(
    1.25,
    Math.hypot((local.x - c.ox) / Math.max(ell.hw, 0.01), (local.y - c.oy) / Math.max(ell.hh, 0.01)),
  );
}
